import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/contests/$id/edit` is the flow, not a screen — Basic info is where it
 * starts. Redirecting in `beforeLoad` rather than rendering a chooser keeps
 * every inbound link to the old single-page URL working, and keeps the browser's
 * back button out of a step that shows nothing.
 */
export const Route = createFileRoute('/contests/$id/edit/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/contests/$id/edit/basic', params, replace: true });
  },
});
